import {Quad, gsap} from "gsap";

export default class TiltController {
    constructor(props) {
        this.elements = document.querySelectorAll('.js-tilted-el');

        if (this.elements.length === 0) {
            return;
        }

        this.init();
    }

    init() {
        for (const element of this.elements) {
            if (element.dataset.rotate === "true") {
                this.elementRotationController(element);
            }

            this.elementRandomController(element);
        }

        document.body.addEventListener('mousemove', (ev) => {
            let x = ev.clientX / window.innerWidth - 0.5;
            let y = ev.clientY / window.innerHeight - 0.5;

            for (const element of this.elements) {
                this.elementTiltController(element, x, y, element.dataset.random);
            }
        });
    }

    elementTiltController(element, x, y, random) {
        let multiplier = element.dataset.multiplier || 10;

        gsap.to(element, 0.5, {
            x: multiplier * x * random,
            y: multiplier * y * random,
            ease: Quad.easeOut,
            transformOrigin: "center"
        });
    }

    elementRandomController(element) {
        let random = parseFloat(Math.random().toFixed(2));
        if (random < 0.5) {
            random = (random + 0.3) * -1;
        }

        element.dataset.random = random;
    }

    elementRotationController(element) {
        const rotation = Math.random() * ((180 / Math.PI) * 2);
        gsap.set(element, {
            rotate: rotation
        });
    }
}
